<script setup lang="ts">
import UserMenu from '../components/UserMenu.vue';
import DefaultSelect from '../components/DefaultSelect.vue';
import NetworkStatus from '../components/NetworkStatus.vue';
import DataSyncDialog from '../components/DataSyncDialog.vue';

import { useSelectCalculator } from '../composables/useSelectCalculator';

const { currentCalculatorId, options, selectCalculator } = useSelectCalculator();
</script>

<template>
  <header class="flex items-center bg-gray-800 px-8 py-6">
    <RouterLink :to="`/${$route.params.calculatorId}`">
      <img src="../assets/logo.png" alt="" />
    </RouterLink>

    <DefaultSelect
      :modelValue="currentCalculatorId"
      class="ml-auto w-24 flex-initial"
      :options="options"
      optionLabel="version"
      optionValue="id"
      @update:modelValue="selectCalculator"
    />

    <NetworkStatus class="mx-3" />

    <DataSyncDialog />

    <UserMenu />
  </header>
</template>
